import { GettingStartedStepInterface } from "./GettingStartedStep/interface";

type GettingStartedStepClass = abstract new (...args: any[]) => GettingStartedStepInterface;

/**
 * Aggregate over the getting-started steps. Owns the rule for which step should
 * auto-expand: the first incomplete step in order, and only that one.
 */
export class GettingStartedChecklist {
  private readonly steps: GettingStartedStepInterface[];

  constructor(steps: GettingStartedStepInterface[]) {
    this.steps = [...steps].sort((a, b) => a.getOrder() - b.getOrder());
  }

  private currentStep(): GettingStartedStepInterface | undefined {
    return this.steps.find(step => !step.isCompleted());
  }

  isComplete(StepClass: GettingStartedStepClass): boolean {
    return !!this.steps.find(step => step instanceof StepClass)?.isCompleted();
  }

  isOpen(StepClass: GettingStartedStepClass): boolean {
    return this.currentStep() instanceof StepClass;
  }
}
